"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateSessionSchema = void 0;
const zod_1 = require("zod");
const CreateSessionSchema = zod_1.z.object({
    Title: zod_1.z.string(),
    Date: zod_1.z.date(),
    Language: zod_1.z.string(),
    Deck: zod_1.z.number(),
    Comment: zod_1.z.string(),
    Animator: zod_1.z.string(), // Keycloak UUID
});
exports.CreateSessionSchema = CreateSessionSchema;
